import { createReducer, INITIAL_STATE } from '@shared/redux';

export const SET_LOG_ROCKET_ACTIVE = '@log-rocket/SET_LOG_ROCKET_ACTIVE';

export interface LogRocketReducer {
    logRocket: {
        shouldInitializeLogRocket: boolean
    };
    setLogRocketActiveStatus: ({ shouldInitializeLogRocket: boolean }) => void;
}

export const setLogRocketActiveStatus = ({ shouldInitializeLogRocket }) => ({
    type: SET_LOG_ROCKET_ACTIVE,
    payload: { shouldInitializeLogRocket },
});

export const logRocketReducer = createReducer({
    [INITIAL_STATE]: { shouldInitializeLogRocket: true },
    [SET_LOG_ROCKET_ACTIVE]: (state, action) => ({
        ...state,
        shouldInitializeLogRocket: action.payload.shouldInitializeLogRocket,
    }),
});
